import axios, { type AxiosResponse } from "axios";
import { SearchResultSchema } from "@/schemas/index";
import type { SearchResultType } from "@/schemas/index";
import env from "@/app/config/env";

export interface ServiceSearchApiType {
  fetchSearchArticle: (query: string) => Promise<SearchResultType>;
}

export const serviceSearchApi: ServiceSearchApiType = {
  fetchSearchArticle: (query) => {
    return axios
      .get(`${env.services.portal}/search`, {
        params: {
          query,
          category: "article",
        },
      })
      .then((response: AxiosResponse<unknown>) => {
        return SearchResultSchema.parse(response.data);
      });
  },
};
